import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { Cancel, Href, PrintInvoice } from "../../../../../Constants/Constants";
import { InvoicePrintType } from "../../../../../Types/EcommerceType";

export const InvoiceButtons: React.FC<InvoicePrintType> = ({ contentRef }) => {
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <span style={{ display: "flex", justifyContent: "center", gap: 15 }} className="pb-5">
      <Link onClick={() => handlePrint()} style={{ background: "#2A5699", color: "rgba(255, 255, 255, 1)", borderRadius: 10, padding: "18px 27px", fontSize: 16, fontWeight: 600, outline: 0, border: 0, textDecoration: "none" }} to={Href}>
        {PrintInvoice}
        <i className="icon-arrow-right" style={{ fontSize: 13, fontWeight: "bold", marginLeft: 10 }} />
      </Link>
      <Link style={{ background: "rgba(122, 112, 186, 0.1)", color: "#2A5699", borderRadius: 10, padding: "18px 27px", fontSize: 16, fontWeight: 600, outline: 0, border: 0, textDecoration: "none" }} to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`} download>
        {Cancel}
        <i className="icon-arrow-right" style={{ fontSize: 13, fontWeight: "bold", marginLeft: 10 }} />
      </Link>
    </span>
  );
};
